import { configureStore } from "@reduxjs/toolkit";
import formReducer from './slices/Activation/formSlice';
import activationReducer from './slices/Activation/activationSlice';

export const store = configureStore({
    reducer: {
        form: formReducer,
        activation: activationReducer
    }
})